import { useCallback } from 'react'
import { UseMutationOptions, useQueryClient } from 'react-query'
import { graphqlGLClient } from '../../api/gqlaxy/gql/queries/graphQLClient'
import {
  ToggleFavoriteListingMutation,
  useToggleFavoriteListingMutation
} from '../../api/gqlaxy/gql/generated/graphql-hooks'
import { QueryKey } from '../../constants/queryKey'
import { useGetFavoriteListingIdsQuery } from '../../store/slices/favoriteListings'

export const useToggleFavoriteListing = (options?: UseMutationOptions<ToggleFavoriteListingMutation, unknown, {}>) => {
  const queryClient = useQueryClient()

  const { refetch } = useGetFavoriteListingIdsQuery(undefined, {})

  const client = graphqlGLClient({
    // endpoint: 'http://127.0.0.1:5001/mobile-staging-376418/us-central1/gqlactus' // Local endpoint
  })

  const handleSettled = useCallback(() => {
    refetch() // TODO: Remove this once old listing card is replaced with new listing card
    queryClient.invalidateQueries({ queryKey: QueryKey.GetFavoriteListings })
  }, [queryClient])

  return useToggleFavoriteListingMutation(client, {
    ...options,
    onSettled: options?.onSettled ?? handleSettled
  })
}
